import { Box, Link, Typography, Divider, styled, Stack } from "fashion/fabrics";
import CardButton from "nodes/core/CardButton";
import BlogHeader from "nodes/blog/BlogHeader";
import { POST_INDEX } from "names/blog";

const SectionStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
}));
const BlogPostStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
}));

const CARD_ID_CONCEPT = "9e44db71-e7a0-473d-9b2d-bcb1bea4c0ec";

const BlogPostIntroduceCardMemoir = () => (
  <BlogPostStack>
    <BlogHeader postIndex={POST_INDEX.BLOG_INTRODUCE_CARD_MEMOIR} />

    <SectionStack>
      <Typography>
        Eliminates the complexity of creating navigable interfaces. We are proud
        to introduce Card Memoir, a groundbreaking new platform that simplifies
        how you create, organize, and share information online. Using an
        intuitive card-based system, Card Memoir lets you build dynamic,
        interconnected webs of knowledge with up to 24 links per card!
      </Typography>
      <Typography component={Link} href="https://concept.memoir.cards">
        concept.memoir.cards
      </Typography>
    </SectionStack>

    <Divider variant="middle" />

    <SectionStack>
      <Typography variant="h4">Reimagine Information Accessibility:</Typography>

      <Typography>
        Card Memoir evolves the limitations of traditional hierarchical
        structures, allowing users to create flexible and engaging interfaces
        with up to 24 visual buttons, or tiles, per card. This unique approach
        fosters deep navigable exploration of any web information while ensuring
        a user-friendly experience.
      </Typography>
    </SectionStack>
    <Box display="flex" justifyContent="center">
      <img
        style={{ maxWidth: "min(100%, 270px)" }}
        src={
          process.env.PUBLIC_URL +
          "/blog/~72da_Content_Introduce Card_Memoir.png"
        }
        alt="Content"
      />
    </Box>

    <Divider variant="middle" />
    <SectionStack>
      <Typography variant="h4">Key Features & Benefits:</Typography>
      <Typography component="ul">
        <li>
          <b>Intuitive Card-Based Interface:</b> Drag-and-drop functionality
          simplifies the creation of navigable interfaces, eliminating the need
          for complex expertise.
        </li>
        <li>
          <b>Enhanced Interconnectivity:</b> With up to 24 links per card, Card
          Memoir facilitates the creation of richly interconnected knowledge
          repositories.
        </li>
        <li>
          <b>Personalized Collections:</b> Curate and organize cards into
          collections tailored to specific needs, enabling efficient access and
          targeted sharing.
        </li>
        <li>
          <b>Publication & Sharing:</b> The Publication Seal feature ensures
          reliability of building cards on a stable network and provides a
          sustainable model to grow the platform.
        </li>
        <li>
          <b>Scalable Solutions:</b> From individual knowledge management to
          enterprise-level information portals, Card Memoir offers adaptable
          solutions to meet diverse needs.
        </li>
      </Typography>
    </SectionStack>

    <Divider variant="middle" />
    <SectionStack>
      <Typography variant="h4">Card Memoir Applications:</Typography>
      <Box display="flex" justifyContent="center">
        <CardButton cardId={CARD_ID_CONCEPT} />
      </Box>
      <Typography component="ul">
        <li>
          <b>Knowledge Management:</b> Consolidate and organize research,
          articles, and online resources into easily accessible personal
          knowledge bases.
        </li>
        <li>
          <b>Education & Training:</b> Develop engaging learning experiences and
          interactive training modules with seamless navigation to rich
          multimedia web integration.
        </li>
        <li>
          <b>Business & Marketing:</b> Showcase products, services, and build
          dynamic customer portals to enhance brand engagement and drive
          conversions.
        </li>
        <li>
          <b>Content Curation & Sharing:</b> Create and share specialized
          resource collections and affiliate links with target audiences in an
          attractive and accessible format.
        </li>
      </Typography>
    </SectionStack>

    <Divider variant="middle" />
    <SectionStack>
      <Typography variant="h4">Partnership Opportunities:</Typography>
      <Typography>
        We are actively seeking strategic partnerships to expand the reach and
        impact of Card Memoir. We invite organizations and individuals
        interested in exploring collaborative opportunities to contact us.
      </Typography>
    </SectionStack>
  </BlogPostStack>
);

export default BlogPostIntroduceCardMemoir;
